module.exports = __webpack_public_path__ + "img/clipboard-diagnosis.a4be0e6a.png";